/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState, useRef } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useParams, useHistory, Link, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Socket.io]
-------------------------------------------------------------------*/
import io from "socket.io-client";
/*------------------------------------------------------------------
[End Socket.io]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_URL, API_SERVER, API_SCT } from '../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
import CurrencyFormat from 'react-currency-format';
import Tour from 'reactour'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev, convertToRupiah } from '../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import ComponentsCredit from '../@tour/@components/credit'
import OverlayBg from '../../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Veriable]
-------------------------------------------------------------------*/
let SOCKET_SERVER = process.env.REACT_APP_PRODUCTION === 'false' ? process.env.REACT_APP_SOCKET_SERVER_DEVELOPMENT : process.env.REACT_APP_SOCKET_SERVER_PRODUCTION;
let socket = io(SOCKET_SERVER);
/*------------------------------------------------------------------
[End Variable]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Screens]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[End Screens]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Components]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[End Components]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [Slug]
    ----------------------------------------------------------------*/
    const { slug } = useParams();
    /*--------------------------------------------------------------
    [Slug]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Meta]
    ----------------------------------------------------------------*/
    let meta_title = 'Ticket';
    /*--------------------------------------------------------------
    [End Meta]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Request Params]
    ----------------------------------------------------------------*/
    let request_params = 'ticket';
    /*--------------------------------------------------------------
    [End Request Params]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Private]
    ----------------------------------------------------------------*/
    let PRIVATE = true;
    /*--------------------------------------------------------------
    [End Private]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Pagination Offset]
    ----------------------------------------------------------------*/
    let pagination_offset = 20;
    /*--------------------------------------------------------------
    [End Pagination Offset]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [tour, set_tour] = useState(false);
    const [tab, set_tab] = useState(null);
    const [filter, set_filter] = useState(null);
    const [sub_filter, set_sub_filter] = useState(null);

    const [refresh, set_refresh] = useState(null);
    const [file, set_file] = useState(null);
    const [bamboo_user, set_bamboo_user] = useState(null);
    const [bamboo_update, set_bamboo_update] = useState('');
    const [bamboo_delete, set_bamboo_delete] = useState('');

    const [table_height, set_table_height] = useState(0);

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);
    const [end_element, set_end_element] = useState(null);
    
    const [pagination_active, set_pagination_active] = useState(1);
    const [path_client, set_path_client] = useState('')
    const [data, set_data] = useState(null);
    const [search, set_search] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [New State]
    ----------------------------------------------------------------*/
    const [test, set_test] = useState('')

    const [judul, set_judul] = useState('')
    const [provinsi , set_provinsi] = useState('')
    const [minimal_orang , set_minimal_orang] = useState('')
    const [maksimal_orang , set_maksimal_orang] = useState('')
    const [lokasi , set_lokasi] = useState('')
    const [jadwal , set_jadwal] = useState('')
    const [durasi , set_durasi] = useState('')
    const [meepo , set_meepo] = useState('')
    const [refund , set_refund] = useState('')
    const [fasilitas , set_fasilitas] = useState('')
    const [itinerary , set_itinerary] = useState('')
    const [price , set_price] = useState(0)
    const [discount , set_discount] = useState(0)
    const [kuota , set_kuota] = useState('')
    const [type , set_type] = useState('')
    /*--------------------------------------------------------------
    [End New State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Ref]
    ----------------------------------------------------------------*/
    const ref_table_height = useRef(null)
    /*--------------------------------------------------------------
    [End Ref]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/
    const steps = [
        {
          selector: '.___step_1',
          content: 'Content 1',
        },
    ];
    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read = (pages, bambooUserParams) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (pagination_offset * pages) - pagination_offset : 0
        
        }

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`tour/ticket/get__________?action=read_${request_params}`
            + '&bamboo_user=' + bambooUserParams
            + '&limit=' + pagination_offset
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            console_dev(`response ${request_params} read`, response.data)
            if(response.data.result == 'success'){
                set_data(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _search = () => {

        if(loading === true){
            return
        }
        
        if(search.length > 3){
    
            API_GET_REQUEST(`tour/ticket/get__________?action=search_${request_params}`
                + '&bamboo_user=' + bamboo_user
                + '&search=' + search
            , 
            ).then((response) => {
                console_dev(`response ${request_params} search`, response.data)
                if(response.data.result == 'success'){
                    set_data(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                }
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }

    }

    const _uploads = (action) => {

        if(loading === true){
            return
        }

        loading(true);

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("bamboo_user", bamboo_user);
        data.append("bamboo_update", bamboo_update);
        data.append("bamboo_delete", bamboo_delete);
        data.append("path_client", path_client);
        data.append("action", action);
        // new request --------------------------------
        data.append("test", test);
        data.append("judul", judul);
        data.append("provinsi", provinsi);
        data.append("minimal_orang", minimal_orang);
        data.append("maksimal_orang", maksimal_orang);
        data.append("lokasi", lokasi);
        data.append("jadwal", jadwal);
        data.append("durasi", durasi);
        data.append("meepo", meepo);
        data.append("refund", refund);
        data.append("fasilitas", JSON.stringify(fasilitas));
        data.append("itinerary", JSON.stringify(itinerary));
        data.append("price", price);
        data.append("discount", discount);
        data.append("kuota", kuota);
        data.append("type", type);
        data.append("uniquename_brand", STORAGE_USER[0].uniquename);
        data.append("tick", STORAGE_USER[0].tick);

        if(file !== null){
            file.map((item) => (
                data.append("file", item)
            ))
        }

        var config = {
            method: 'post',
            url: API_URL + "tour/ticket/post__________",
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                if(file !== null){
                    progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
                }
            }
        };

        axios(config)
        .then((response) => {
            console_dev(`response ${request_params} uploads`, response.data)
            if(response.data.result === 'success'){
                _read(pagination_active, bamboo_user)
                set_file(null)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                set_path_client('')
                // update state ------------------
                set_test('')
                set_judul('')
                set_provinsi('')
                set_minimal_orang('')
                set_maksimal_orang('')
                set_lokasi('')
                set_jadwal('')
                set_durasi('')
                set_meepo('')
                set_refund('')
                set_fasilitas('')
                set_itinerary('')
                set_price(0)
                set_discount(0)
                set_kuota('')
                set_type('')
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console_dev('catch', e)
            error(e.message)
        })
        .finally(() => {
			loading(false);
		})

    }

    const _uploads_post = (params) => {

        if(loading === true){
            return 
        }

		loading(true);

		API_POST('tour/ticket/post__________', {
            bamboo_user: bamboo_user,
            bamboo_update: bamboo_update,
            bamboo_delete: bamboo_delete,
            action: params,
            // new request ------------------------
            test: test,
		}).then((response) => {
            console_dev(`response ${request_params} uploads post`, response.data)
            if(response.data.result == 'success'){
                _read(pagination_active, bamboo_user)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                // update state ------------------
                set_test('')
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Socket]
    ----------------------------------------------------------------*/
    const _socket_online = (storageUserParams) => {

        // // get
		// socket.on("get", (data) => {
		// 	console.log('get : ', data)	
		// })
		
		// // push
		// socket.emit("push", {
		// 	push : data,
		// });

        // socket.on("forum_user_authentication", (data) => {
		// 	console.log('forum_user_authentication : ', data)	
		// })

        // socket.emit("forum_user_authentication", {
        //     action: 'connect',
        //     room: 'room_forum_user_authentication',
        //     status: 'online',
        //     bamboo_user : storageUserParams.bamboo,
        //     username : storageUserParams.username,
        //     name : storageUserParams.name,
        //     e_account : storageUserParams.e_account,
        // });
		
	}

    const _socket_offline = (storageUserParams) => {

        // // get
		// socket.on("get", (data) => {
		// 	console.log('get : ', data)	
		// })
		
		// // push
		// socket.emit("push", {
		// 	push : data,
		// });

        // socket.on("forum_user_authentication", (data) => {
		// 	console.log('forum_user_authentication : ', data)	
		// })

        // socket.emit("forum_user_authentication", {
        //     action: 'disconnect',
        //     room: 'room_forum_user_authentication',
        //     status: 'offline',
        //     bamboo_user : storageUserParams.bamboo,
        //     username : storageUserParams.username,
        //     name : storageUserParams.name,
        //     e_account : storageUserParams.e_account,
        // });
		
	}
    /*--------------------------------------------------------------
    [End Socket]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    
    const _files_multiple = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        let data = [...event.target.files]
        
        if(data){

            console_dev('data', data)

            data.map((item, index) => {
                // console.log('item', data)
                if(item.size > 2048000){
                    return error('Ukuran File maxsimal 2MB')
                }else{
                    set_file([...data])
                }

            })

        }
        
	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        if(STORAGE_USER !== undefined){

            let storage_bamboo = STORAGE_USER[0].level === 'admin' ? STORAGE_USER[0].bamboo : STORAGE_USER[0].bamboo_chain;
            
            if(storage_bamboo){
                set_bamboo_user(storage_bamboo)
                _socket_online(STORAGE_USER[0])
                _read(1, storage_bamboo)
            }

        }else{

            error('User Not Found')
        
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Authentication]
    ----------------------------------------------------------------*/
    if(PRIVATE === true){
        if(STORAGE_USER !== undefined){
            if(STORAGE_USER[0].level === 'guest'){
                history.push('/')
            }
        }else{
            history.push('/home')
            window.location.reload();
        }
    }
    /*--------------------------------------------------------------
    [End Authentication]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search.length > 0){
            _search()
        }else{
            _STORAGE_USER()
        }

    }, [refresh, search])

    useEffect(() => {

        if(ref_table_height.current){
            set_table_height(ref_table_height.current.clientHeight + 10)
        }

    }, [data])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    return (
        <>

            {/*  Helmet ------------------------------------------------------------------ */}
            <Helmet>

                <meta name="description" content={`${meta_title}`}/>
                <title>{`${meta_title}`}</title>

            </Helmet>
            {/*  End Helmet -------------------------------------------------------------- */}

            {/*  Tour -------------------------------------------------------------------- */}
            <Tour steps={steps} isOpen={tour} onRequestClose={() => set_tour(false)} />
            <Tour disableKeyboardNavigation={['esc']} />
            {/*  End Tour ---------------------------------------------------------------- */}

            {/*  Header ------------------------------------------------------------------ */}
            <div className="_row _center_align">
                <div className="_column">
                    <h1 style={{marginBottom: 30}}><span style={{color: '#118ab2'}}>e-</span>{meta_title}</h1>
                </div>
            </div>
            
            <div className="_row _center_align _push_b_d">
                <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                <p className="_push_l_m">Kendali penuh untuk mengatur bagian {meta_title}</p>
            </div>
            {/*  End Header --------------------------------------------------------------- */}

            {/*  Add ---------------------------------------------------------------------- */}
            <div className="_row _center_align _push_b_d">
                <div className="_column">
                    <div className="_font_size_20px">Data Cloud <ion-icon name="cloud-done-outline" style={{fontSize: 30, marginBottom: -6, marginLeft: 8, color: 'seagreen'}}></ion-icon></div>
                </div>
                <div>
                    <div onClick={() => {
                        if(element === 'overlay'){
                            set_element(null)
                        }else{
                            set_element('overlay')
                        }
                    }} className="_btn _cursor_pointer">
                        Tambah
                    </div>

                    {
                        element === 'overlay' ?
                            <>
                                <div className="_fmc_overlay">
                                    <div className="_fmc_overlay_navbar">
                                        <div className="_row _center_align">
                                            <div className="_column">
                                                <p className="_font_size_18px">Tambah Data</p>
                                            </div>
                                            <div onClick={() => {
                                                if(element === 'overlay'){
                                                    set_element(null)
                                                }else{
                                                    set_element('overlay')
                                                }
                                            }} className="_push_l_d _btn _cursor_pointer">
                                                Keluar
                                            </div>
                                        </div>
                                    </div>
                                    <div className="_fmc_overlay_content">
                                        <div className="_container">
                                            <div>
                                                <div className="_row _push_t_g _push_b_g">
                                                    <div className="_column">
                                                        <div className="_heading_bold _push_b_l">
                                                            Cloud : <span className="_grey">Semua Data Akan Disimpan Pada Server Kami.</span>
                                                        </div>
                                                        <div className="_row _center_align _push_b_s">
                                                            <div className="_relative _column _push_b_d">
                                                                <p style={{color: '#888', fontSize: 13, marginBottom: 8}}>
                                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                    Fasilitas
                                                                </p>
                                                                <div onClick={() => {
                                                                    if(sub_element === 'fasilitas'){
                                                                        set_sub_element(null)
                                                                    }else{
                                                                        set_sub_element('fasilitas')
                                                                    }
                                                                }} className="_btn _cursor_pointer">
                                                                    Editor
                                                                </div>

                                                                {
                                                                    sub_element === 'fasilitas' ?
                                                                        <>
                                                                            <div className="_fmc_overlay">
                                                                                <div className="_fmc_overlay_navbar">
                                                                                    <div className="_row _center_align">
                                                                                        <div className="_column">
                                                                                            <p className="_font_size_18px">Fasilitas</p>
                                                                                        </div>
                                                                                        <div onClick={() => {
                                                                                            if(sub_element === 'fasilitas'){
                                                                                                set_sub_element(null)
                                                                                            }else{
                                                                                                set_sub_element('fasilitas')
                                                                                            }
                                                                                        }} className="_push_l_d _btn _cursor_pointer">
                                                                                            Simpan
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="_fmc_overlay_content">
                                                                                    <div className="_container">
                                                                                        <CKEditor
                                                                                            onReady={ editor => {
                                                                                                // console.log( 'Editor is ready to use!', editor );

                                                                                                // Insert the toolbar before the editable area.
                                                                                                editor.ui.getEditableElement().parentElement.insertBefore(
                                                                                                    editor.ui.view.toolbar.element,
                                                                                                    editor.ui.getEditableElement()
                                                                                                );

                                                                                                editor = editor;
                                                                                            } }
                                                                                            onError={ ( { willEditorRestart } ) => {
                                                                                                // If the editor is restarted, the toolbar element will be created once again.
                                                                                                // The `onReady` callback will be called again and the new toolbar will be added.
                                                                                                // This is why you need to remove the older toolbar.
                                                                                                if ( willEditorRestart ) {
                                                                                                    // this.editor.ui.view.toolbar.element.remove();
                                                                                                }
                                                                                            } }
                                                                                            onChange={(event, editor) => {
                                                                                                // console.log({ event, editor}) 
                                                                                                // console.log(editor.getData());
                                                                                                set_fasilitas(editor.getData())
                                                                                            }}
                                                                                            editor={DecoupledEditor}
                                                                                            data={fasilitas}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    : null
                                                                }
                                                            </div>
                                                            {/* <div className="_relative _column _push_b_d">
                                                                <p style={{color: '#888', fontSize: 13, marginBottom: 8}}>
                                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                    Itinerary
                                                                </p>
                                                                <div onClick={() => {
                                                                    if(sub_element === 'itinerary'){
                                                                        set_sub_element(null)
                                                                    }else{
                                                                        set_sub_element('itinerary')
                                                                    }
                                                                }} className="_btn _cursor_pointer">
                                                                    Editor
                                                                </div>

                                                                {
                                                                    sub_element === 'itinerary' ?
                                                                        <>
                                                                            <div className="_fmc_overlay">
                                                                                <div className="_fmc_overlay_navbar">
                                                                                    <div className="_row _center_align">
                                                                                        <div className="_column">
                                                                                            <p className="_font_size_18px">Itinerary</p>
                                                                                        </div>
                                                                                        <div onClick={() => {
                                                                                            if(sub_element === 'itinerary'){
                                                                                                set_sub_element(null)
                                                                                            }else{
                                                                                                set_sub_element('itinerary')
                                                                                            }
                                                                                        }} className="_push_l_d _btn _cursor_pointer">
                                                                                            Simpan
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="_fmc_overlay_content">
                                                                                    <div className="_container">
                                                                                        <CKEditor
                                                                                            onReady={ editor => {
                                                                                                // console.log( 'Editor is ready to use!', editor );

                                                                                                // Insert the toolbar before the editable area.
                                                                                                editor.ui.getEditableElement().parentElement.insertBefore(
                                                                                                    editor.ui.view.toolbar.element,
                                                                                                    editor.ui.getEditableElement()
                                                                                                );

                                                                                                editor = editor;
                                                                                            } }
                                                                                            onError={ ( { willEditorRestart } ) => {
                                                                                                // If the editor is restarted, the toolbar element will be created once again.
                                                                                                // The `onReady` callback will be called again and the new toolbar will be added.
                                                                                                // This is why you need to remove the older toolbar.
                                                                                                if ( willEditorRestart ) {
                                                                                                    // this.editor.ui.view.toolbar.element.remove();
                                                                                                }
                                                                                            } }
                                                                                            onChange={(event, editor) => {
                                                                                                // console.log({ event, editor}) 
                                                                                                // console.log(editor.getData());
                                                                                                set_itinerary(editor.getData())
                                                                                            }}
                                                                                            editor={DecoupledEditor}
                                                                                            data={itinerary}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    : null
                                                                }
                                                            </div>
                                                         */}
                                                        </div>
                                                        
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Judul
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_judul(e.target.value)}
                                                                    value={judul}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_center_align">
                                                            <div className="_relative _column _push_b_d">
                                                                <p style={{color: '#888', fontSize: 13}}>
                                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                    Provinsi
                                                                </p>
                                                                <div className="_e_input">
                                                                    <input 
                                                                        placeholder=""
                                                                        type={'text'} 
                                                                        onChange={e => set_provinsi(e.target.value)}
                                                                        value={provinsi}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="_relative _column _push_b_d">
                                                                <p style={{color: '#888', fontSize: 13}}>
                                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                    Lokasi
                                                                </p>
                                                                <div className="_e_input">
                                                                    <input 
                                                                        placeholder=""
                                                                        type={'text'} 
                                                                        onChange={e => set_lokasi(e.target.value)}
                                                                        value={lokasi}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="_row _center_align">
                                                            <div className="_relative _column _push_b_d">
                                                                <p style={{color: '#888', fontSize: 13}}>
                                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                    Minimal Orang
                                                                </p>
                                                                <div className="_e_input">
                                                                    <input 
                                                                        placeholder=""
                                                                        type={'number'}
                                                                        onChange={e => set_minimal_orang(e.target.value)}
                                                                        value={minimal_orang}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="_relative _column _push_b_d">
                                                                <p style={{color: '#888', fontSize: 13}}>
                                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                    Maksimal Orang
                                                                </p>
                                                                <div className="_e_input">
                                                                    <input 
                                                                        placeholder=""
                                                                        type={'number'}
                                                                        onChange={e => set_maksimal_orang(e.target.value)}
                                                                        value={maksimal_orang}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Jadwal
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_jadwal(e.target.value)}
                                                                    value={jadwal}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Durasi
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_durasi(e.target.value)}
                                                                    value={durasi}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Meeting Point
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_meepo(e.target.value)}
                                                                    value={meepo}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Refund
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_refund(e.target.value)}
                                                                    value={refund}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="_row _column">
                                                            <div className="_relative _column _push_b_d">
                                                                <p style={{color: '#888', fontSize: 13}}>
                                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                    Price
                                                                </p>
                                                                <div className="_e_input">
                                                                    <input 
                                                                        placeholder=""
                                                                        type={'text'} 
                                                                        onChange={e => set_price(e.target.value)}
                                                                        value={price}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="_relative _push_b_d">
                                                                <p style={{color: '#888', fontSize: 13}}>
                                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                    Discount
                                                                </p>
                                                                <div className="_e_input">
                                                                    <input 
                                                                        placeholder=""
                                                                        type={'text'} 
                                                                        onChange={e => set_discount(e.target.value)}
                                                                        value={discount}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Kuota
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_kuota(e.target.value)}
                                                                    value={kuota}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Type
                                                            </p>
                                                            <div className="_e_input">
                                                                <div className="_row _center_align">
                                                                    <div className="_column">
                                                                        <input 
                                                                            placeholder=""
                                                                            type={'type'} 
                                                                            onChange={e => set_type(e.target.value)}
                                                                            value={type}
                                                                        />
                                                                    </div>
                                                                    <div onClick={() => {
                                                                        if(sub_element === 'sub_dropdown'){
                                                                            set_sub_element(null)
                                                                        }else{
                                                                            set_sub_element('sub_dropdown')
                                                                        }
                                                                    }} className="_btn _cursor_pointer" style={{backgroundColor: type === 'sub_dropdown' ? '#eee' : null}}>
                                                                        <div className="_row _center_align">
                                                                            <div className="_push_t_t">
                                                                                {
                                                                                    type === 'sub_dropdown' ?
                                                                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                                                                    :
                                                                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="_relative">
                                                                    {
                                                                        sub_element === 'sub_dropdown' ?
                                                                            // _left or _right
                                                                            <>
                                                                                <div className="_fmc_overlay_dropdown _right">
                                                                                    <div onClick={() => {set_type('Pesawat')}} className="_item" style={{backgroundColor: type === 'Pesawat' ? '#eee' : null}}>Pesawat</div>
                                                                                    <div onClick={() => {set_type('Kereta Api')}} className="_item" style={{backgroundColor: type === 'Kereta Api' ? '#eee' : null}}>Kereta Api</div>
                                                                                    <div onClick={() => {set_type('Bus')}} className="_item" style={{backgroundColor: type === 'Bus' ? '#eee' : null}}>Bus</div>
                                                                                </div>
                                                                            </>
                                                                        : null
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Input
                                                            </p>
                                                            <div className="_e_input">
                                                                <div className="_row _center_align">
                                                                    <div className="_push_r_t">
                                                                        Rp.
                                                                    </div>
                                                                    <div className="_column">
                                                                        <CurrencyFormat 
                                                                            value={input} 
                                                                            thousandSeparator={true} 
                                                                            prefix={''}
                                                                            onValueChange={(e) => {
                                                                                if(e.value.length < 10){
                                                                                    set_input(e.value)
                                                                                }else{
                                                                                    set_input('')
                                                                                    error('Max Length')
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                        {/* <p className="_push_b_m _cl_smooth_0">Description</p> */}
                                                        <div className="_bb-input _push_b_d" style={{marginTop: -16}}>
                                                            <div className="_e_input">
                                                                <input
                                                                    className="custom-file-input" 
                                                                    type="file"
                                                                    name="file"
                                                                    placeholder=""
                                                                    onChange={_files}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div onClick={() => {
                                                            // _uploads_post(`insert_${request_params}`)
                                                            _uploads(`insert_${request_params}`)
                                                        }} className="_btn _cursor_pointer">
                                                            Simpan
                                                        </div>
                                                    </div>
                                                    <div className="_fmc_overlay_bg_hide">
                                                        <img style={{width: 400}} src={OverlayBg}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        : null
                    }
                </div>
            </div>
            {/*  Add ---------------------------------------------------------------------- */}

            {/*  Delete & Update ---------------------------------------------------------- */}
            {
                bamboo_delete.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Hapus Data</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_delete('')
                                    set_path_client('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_container">
                                <div className="_lily_pad_h_d">
                                    <div className="_row _push_t_g _push_b_g">
                                        <div className="_column">
                                            <div className="_heading_bold _push_b_l">
                                                Cloud : <span className="_grey">Data Akan Dihapus Pada Server Kami.</span>
                                            </div>
                                            <div onClick={() => {
                                                // _uploads_post(`delete_${request_params}`)
                                                _uploads(`delete_${request_params}`)
                                            }} className="_btn _cursor_pointer">
                                                Hapus
                                            </div>
                                        </div>
                                        <div className="_fmc_overlay_bg_hide">
                                            <img style={{width: 400}} src={OverlayBg}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }

            {
                bamboo_update.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Perbaharui Data</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_update('')
                                    set_path_client('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_container">
                                <div className="_lily_pad_h_d">
                                    <div className="_row _push_t_g _push_b_g">
                                        <div className="_column">
                                            <div className="_heading_bold _push_b_l">
                                                Cloud : <span className="_grey">Semua Data Akan Disimpan Pada Server Kami.</span>
                                            </div>
                                            <div className="_row _center_align _push_b_s">
                                                <div className="_relative _column _push_b_d">
                                                    <p style={{color: '#888', fontSize: 13, marginBottom: 8}}>
                                                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                        Fasilitas
                                                    </p>
                                                    <div onClick={() => {
                                                        if(sub_element === 'fasilitas'){
                                                            set_sub_element(null)
                                                        }else{
                                                            set_sub_element('fasilitas')
                                                        }
                                                    }} className="_btn _cursor_pointer">
                                                        Editor
                                                    </div>

                                                    {
                                                        sub_element === 'fasilitas' ?
                                                            <>
                                                                <div className="_fmc_overlay">
                                                                    <div className="_fmc_overlay_navbar">
                                                                        <div className="_row _center_align">
                                                                            <div className="_column">
                                                                                <p className="_font_size_18px">Fasilitas</p>
                                                                            </div>
                                                                            <div onClick={() => {
                                                                                if(sub_element === 'fasilitas'){
                                                                                    set_sub_element(null)
                                                                                }else{
                                                                                    set_sub_element('fasilitas')
                                                                                }
                                                                            }} className="_push_l_d _btn _cursor_pointer">
                                                                                Simpan
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="_fmc_overlay_content">
                                                                        <div className="_container">
                                                                            <CKEditor
                                                                                onReady={ editor => {
                                                                                    // console.log( 'Editor is ready to use!', editor );

                                                                                    // Insert the toolbar before the editable area.
                                                                                    editor.ui.getEditableElement().parentElement.insertBefore(
                                                                                        editor.ui.view.toolbar.element,
                                                                                        editor.ui.getEditableElement()
                                                                                    );

                                                                                    editor = editor;
                                                                                } }
                                                                                onError={ ( { willEditorRestart } ) => {
                                                                                    // If the editor is restarted, the toolbar element will be created once again.
                                                                                    // The `onReady` callback will be called again and the new toolbar will be added.
                                                                                    // This is why you need to remove the older toolbar.
                                                                                    if ( willEditorRestart ) {
                                                                                        // this.editor.ui.view.toolbar.element.remove();
                                                                                    }
                                                                                } }
                                                                                onChange={(event, editor) => {
                                                                                    // console.log({ event, editor}) 
                                                                                    // console.log(editor.getData());
                                                                                    set_fasilitas(editor.getData())
                                                                                }}
                                                                                editor={DecoupledEditor}
                                                                                data={fasilitas}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        : null
                                                    }
                                                </div>
                                                {/* <div className="_relative _column _push_b_d">
                                                    <p style={{color: '#888', fontSize: 13, marginBottom: 8}}>
                                                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                        Itinerary
                                                    </p>
                                                    <div onClick={() => {
                                                        if(sub_element === 'itinerary'){
                                                            set_sub_element(null)
                                                        }else{
                                                            set_sub_element('itinerary')
                                                        }
                                                    }} className="_btn _cursor_pointer">
                                                        Editor
                                                    </div>

                                                    {
                                                        sub_element === 'itinerary' ?
                                                            <>
                                                                <div className="_fmc_overlay">
                                                                    <div className="_fmc_overlay_navbar">
                                                                        <div className="_row _center_align">
                                                                            <div className="_column">
                                                                                <p className="_font_size_18px">Itinerary</p>
                                                                            </div>
                                                                            <div onClick={() => {
                                                                                if(sub_element === 'itinerary'){
                                                                                    set_sub_element(null)
                                                                                }else{
                                                                                    set_sub_element('itinerary')
                                                                                }
                                                                            }} className="_push_l_d _btn _cursor_pointer">
                                                                                Simpan
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="_fmc_overlay_content">
                                                                        <div className="_container">
                                                                            <CKEditor
                                                                                onReady={ editor => {
                                                                                    // console.log( 'Editor is ready to use!', editor );

                                                                                    // Insert the toolbar before the editable area.
                                                                                    editor.ui.getEditableElement().parentElement.insertBefore(
                                                                                        editor.ui.view.toolbar.element,
                                                                                        editor.ui.getEditableElement()
                                                                                    );

                                                                                    editor = editor;
                                                                                } }
                                                                                onError={ ( { willEditorRestart } ) => {
                                                                                    // If the editor is restarted, the toolbar element will be created once again.
                                                                                    // The `onReady` callback will be called again and the new toolbar will be added.
                                                                                    // This is why you need to remove the older toolbar.
                                                                                    if ( willEditorRestart ) {
                                                                                        // this.editor.ui.view.toolbar.element.remove();
                                                                                    }
                                                                                } }
                                                                                onChange={(event, editor) => {
                                                                                    // console.log({ event, editor}) 
                                                                                    // console.log(editor.getData());
                                                                                    set_itinerary(editor.getData())
                                                                                }}
                                                                                editor={DecoupledEditor}
                                                                                data={itinerary}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        : null
                                                    }
                                                </div>
                                            */}
                                            </div>
                                            
                                            <div className="_relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    Judul
                                                </p>
                                                <div className="_e_input">
                                                    <input 
                                                        placeholder=""
                                                        type={'text'} 
                                                        onChange={e => set_judul(e.target.value)}
                                                        value={judul}
                                                    />
                                                </div>
                                            </div>
                                            <div className="_center_align">
                                                <div className="_relative _column _push_b_d">
                                                    <p style={{color: '#888', fontSize: 13}}>
                                                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                        Provinsi
                                                    </p>
                                                    <div className="_e_input">
                                                        <input 
                                                            placeholder=""
                                                            type={'text'} 
                                                            onChange={e => set_provinsi(e.target.value)}
                                                            value={provinsi}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="_relative _column _push_b_d">
                                                    <p style={{color: '#888', fontSize: 13}}>
                                                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                        Lokasi
                                                    </p>
                                                    <div className="_e_input">
                                                        <input 
                                                            placeholder=""
                                                            type={'text'} 
                                                            onChange={e => set_lokasi(e.target.value)}
                                                            value={lokasi}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="_row _center_align">
                                                <div className="_relative _column _push_b_d">
                                                    <p style={{color: '#888', fontSize: 13}}>
                                                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                        Minimal Orang
                                                    </p>
                                                    <div className="_e_input">
                                                        <input 
                                                            placeholder=""
                                                            type={'number'}
                                                            onChange={e => set_minimal_orang(e.target.value)}
                                                            value={minimal_orang}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="_relative _column _push_b_d">
                                                    <p style={{color: '#888', fontSize: 13}}>
                                                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                        Maksimal Orang
                                                    </p>
                                                    <div className="_e_input">
                                                        <input 
                                                            placeholder=""
                                                            type={'number'}
                                                            onChange={e => set_maksimal_orang(e.target.value)}
                                                            value={maksimal_orang}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="_relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    Jadwal
                                                </p>
                                                <div className="_e_input">
                                                    <input 
                                                        placeholder=""
                                                        type={'text'} 
                                                        onChange={e => set_jadwal(e.target.value)}
                                                        value={jadwal}
                                                    />
                                                </div>
                                            </div>
                                            <div className="_relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    Durasi
                                                </p>
                                                <div className="_e_input">
                                                    <input 
                                                        placeholder=""
                                                        type={'text'} 
                                                        onChange={e => set_durasi(e.target.value)}
                                                        value={durasi}
                                                    />
                                                </div>
                                            </div>
                                            <div className="_relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    Meeting Point
                                                </p>
                                                <div className="_e_input">
                                                    <input 
                                                        placeholder=""
                                                        type={'text'} 
                                                        onChange={e => set_meepo(e.target.value)}
                                                        value={meepo}
                                                    />
                                                </div>
                                            </div>
                                            <div className="_relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    Refund
                                                </p>
                                                <div className="_e_input">
                                                    <input 
                                                        placeholder=""
                                                        type={'text'} 
                                                        onChange={e => set_refund(e.target.value)}
                                                        value={refund}
                                                    />
                                                </div>
                                            </div>

                                            <div className="_row _column">
                                                <div className="_relative _column _push_b_d">
                                                    <p style={{color: '#888', fontSize: 13}}>
                                                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                        Price
                                                    </p>
                                                    <div className="_e_input">
                                                        <input 
                                                            placeholder=""
                                                            type={'text'} 
                                                            onChange={e => set_price(e.target.value)}
                                                            value={price}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="_relative _push_b_d">
                                                    <p style={{color: '#888', fontSize: 13}}>
                                                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                        Discount
                                                    </p>
                                                    <div className="_e_input">
                                                        <input 
                                                            placeholder=""
                                                            type={'text'} 
                                                            onChange={e => set_discount(e.target.value)}
                                                            value={discount}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="_relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    Kuota
                                                </p>
                                                <div className="_e_input">
                                                    <input 
                                                        placeholder=""
                                                        type={'text'} 
                                                        onChange={e => set_kuota(e.target.value)}
                                                        value={kuota}
                                                    />
                                                </div>
                                            </div>
                                            <div className="_relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    Type
                                                </p>
                                                <div className="_e_input">
                                                    <div className="_row _center_align">
                                                        <div className="_column">
                                                            <input 
                                                                placeholder=""
                                                                type={'type'} 
                                                                onChange={e => set_type(e.target.value)}
                                                                value={type}
                                                            />
                                                        </div>
                                                        <div onClick={() => {
                                                            if(sub_element === 'sub_dropdown'){
                                                                set_sub_element(null)
                                                            }else{
                                                                set_sub_element('sub_dropdown')
                                                            }
                                                        }} className="_btn _cursor_pointer" style={{backgroundColor: type === 'sub_dropdown' ? '#eee' : null}}>
                                                            <div className="_row _center_align">
                                                                <div className="_push_t_t">
                                                                    {
                                                                        type === 'sub_dropdown' ?
                                                                            <ion-icon name="chevron-up-outline"></ion-icon>
                                                                        :
                                                                            <ion-icon name="chevron-down-outline"></ion-icon>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="_relative">
                                                        {
                                                            sub_element === 'sub_dropdown' ?
                                                                // _left or _right
                                                                <>
                                                                    <div className="_fmc_overlay_dropdown _right">
                                                                        <div onClick={() => {set_type('Makanan')}} className="_item" style={{backgroundColor: type === 'Makanan' ? '#eee' : null}}>Makanan</div>
                                                                        <div onClick={() => {set_type('Minuman')}} className="_item" style={{backgroundColor: type === 'Minuman' ? '#eee' : null}}>Minuman</div>
                                                                    </div>
                                                                </>
                                                            : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="_relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    Input
                                                </p>
                                                <div className="_e_input">
                                                    <div className="_row _center_align">
                                                        <div className="_push_r_t">
                                                            Rp.
                                                        </div>
                                                        <div className="_column">
                                                            <CurrencyFormat 
                                                                value={input} 
                                                                thousandSeparator={true} 
                                                                prefix={''}
                                                                onValueChange={(e) => {
                                                                    if(e.value.length < 10){
                                                                        set_input(e.value)
                                                                    }else{
                                                                        set_input('')
                                                                        error('Max Length')
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}
                                            {/* <p className="_push_b_m _cl_smooth_0">Description</p> */}
                                            <div className="_bb-input _push_b_d" style={{marginTop: -16}}>
                                                <div className="_e_input">
                                                    <input
                                                        className="custom-file-input" 
                                                        type="file"
                                                        name="file"
                                                        placeholder=""
                                                        onChange={_files}
                                                    />
                                                </div>
                                            </div>
                                        
                                            <div onClick={() => {
                                                // _uploads_post(`update_${request_params}`)
                                                if(file === null){
                                                    _uploads(`update_text_${request_params}`)
                                                }else{
                                                    _uploads(`update_file_${request_params}`)
                                                }
                                            }} className="_btn _cursor_pointer">
                                                Simpan
                                            </div>
                                        </div>
                                        <div className="_fmc_overlay_bg_hide">
                                            <img style={{width: 400}} src={OverlayBg}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }
            {/*  End Delete & Update ------------------------------------------------------- */}


            {/*  Search -------------------------------------------------------------------- */}
            <div className="_bb_search _push_b_d" style={{backgroundColor: 'transparent'}}>
                <div className="_row _center_align">
                    <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                    <div className="_column">
                        <input 
                            placeholder="Cari" 
                            onChange={e => set_search(e.target.value)}
                            value={search}
                        />
                    </div>
                </div>
            </div>
            {/*  End Search ---------------------------------------------------------------- */}

            {/*  Table --------------------------------------------------------------------- */}
            <div className="_data_table_transition" style={{height: table_height}}>
                <div className="_overflow_x" ref={ref_table_height}>
                    <table className="_table">
                        <thead>
                            <tr>
                                <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                                <th>Gambar</th>
                                <th>Judul</th>
                                <th>Lokasi</th>
                                <th>Price</th>
                                <th>
                                    <div className="_right_text">
                                        <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data && data.list.length > 0 ? 
                                    data.list.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>
                                                <a href={API_SERVER + '/' + item.path + '/' + item.file} target="_blank"><ion-icon name="image-outline" style={{fontSize: 22, marginBottom: -3}}></ion-icon></a>
                                            </td>
                                            <td>{decode(item.judul)}</td>
                                            <td>{decode(item.lokasi)}</td>
                                            <td>{convertToRupiah(decode(item.price))}</td>
                                            <td>
                                                <div className="_right_text _text_overflow">
                                                    <div onClick={() => {
                                                        set_path_client(item.path)
                                                        set_bamboo_delete(item.bamboo)
                                                    }} className="_btn _cursor_pointer _push_r_m">
                                                        Delete
                                                    </div>
                                                    <div onClick={() => {
                                                        set_path_client(item.path)
                                                        set_bamboo_update(item.bamboo)
                                                        // update state -------------------------
                                                        set_test(decode(item.kode))
                                                        set_judul(decode(item.judul))
                                                        set_provinsi(decode(item.provinsi))
                                                        set_minimal_orang(decode(item.minimal_orang))
                                                        set_maksimal_orang(decode(item.maksimal_orang))
                                                        set_lokasi(decode(item.lokasi))
                                                        set_jadwal(decode(item.jadwal))
                                                        set_durasi(decode(item.durasi))
                                                        set_meepo(decode(item.meepo))
                                                        set_refund(decode(item.refund))
                                                        set_fasilitas(JSON.parse(decode(item.fasilitas)))
                                                        set_itinerary(JSON.parse(decode(item.itinerary)))
                                                        set_price(decode(item.price))
                                                        set_discount(decode(item.discount))
                                                        set_kuota(decode(item.kuota))
                                                        set_type(decode(item.type))
                                                    }} className="_btn _cursor_pointer _push_r_m">
                                                        Update
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))

                                :
                                    data &&
                                    <tr>
                                        <td colSpan="10">Belum Ada Data</td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            {/*  End Table ----------------------------------------------------------------- */}

            {/*  Pagination ---------------------------------------------------------------- */}
            <div className="_lily_pad_h_d _push_b_d _push_t_d">
                <div className="__pagination">
                    {
                        data&&data.pages.map((item, index) => {
                            if(data.pages.length > 1){
                                return (

                                    <div 
                                        key={index} 
                                        className="__item"
                                        style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                        onClick={() => {
                                            _read(index + 1, bamboo_user);
                                            set_pagination_active(index + 1)
                                        }}
                                    >
                                        <div className="_position_middle">
                                            {item}
                                        </div>
                                    </div>
                                    
                                )
                            }
                        })
                    }
                </div>
            </div>
            {/*  End Pagination -------------------------------------------------------------*/}

            {/*  Credit -------------------------------------------------------------------- */}
            {
                data && 
                    data.pages.length === 1 ?
                        <ComponentsCredit/>
                    :
                        data && data.list.length > 0 ?
                            null
                        :
                            <ComponentsCredit/>
                            
            }
            {/*  End Credit ---------------------------------------------------------------- */}

            {/*  Documentation ------------------------------------------------------------- */}

                {/* <div className="_row _center_align">
                    <div className="_column">

                    </div>
                    <div className="_column">
                        
                    </div>
                </div> */}

                {/* <div onClick={() => {
                    if(element === 'overlay'){
                        set_element(null)
                    }else{
                        set_element('overlay')
                    }
                }} className="_btn _cursor_pointer">
                    fmc overlay btn
                </div>

                {
                    element === 'overlay' ?
                        <>
                            <div className="_fmc_overlay">
                                <div className="_fmc_overlay_navbar">
                                    <div className="_row _center_align">
                                        <div className="_column">
                                            <p className="_font_size_18px">Overlay</p>
                                        </div>
                                        <div onClick={() => {
                                            if(element === 'overlay'){
                                                set_element(null)
                                            }else{
                                                set_element('overlay')
                                            }
                                        }} className="_push_l_d _btn _cursor_pointer">
                                            Keluar
                                        </div>
                                    </div>
                                </div>
                                <div className="_fmc_overlay_content">

                                </div>
                            </div>
                        </>
                    : null
                }

                <div className="_relative">
                    <div onClick={() => {
                        if(element === 'overlay_dropdown'){
                            set_element(null)
                        }else{
                            set_element('overlay_dropdown')
                        }
                    }} className="_btn _cursor_pointer">
                        <div className="_row _center_align">
                            <div className="_column">
                                fmc overlay dropdown btn
                            </div>
                            <div className="_push_l_m _push_t_t">
                                {
                                    element === 'overlay_dropdown' ?
                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                    :
                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                }
                            </div>
                        </div>
                    </div>
                    {
                        element === 'overlay_dropdown' ?
                            // _left or _right
                            <>
                                <div className="_fmc_overlay_dropdown _left">
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                </div>
                            </>
                        : null
                    }
                </div>

                <div className="_relative _push_b_m">
                    <p style={{color: '#888', fontSize: 13}}>
                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                        Input
                    </p>
                    <div className="_e_input">
                        <input 
                            placeholder=""
                            type={'text'} 
                            // onChange={e => set_input(e.target.value)}
                            // value={input}
                        />
                    </div>
                </div>

                <div className="_bb-input" style={{paddingBottom: 10, paddingTop: 10}}>
                                        
                    <input
                        className="custom-file-input" 
                        type="file"
                        name="file"
                        placeholder=""
                        onChange={_files}
                    />

                </div>

                <div onClick={() => {
                    _uploads()
                }} className="_btn _cursor_pointer">
                    Simpan
                </div>

                <div className="_bb_search" style={{backgroundColor: 'transparent'}}>
                    <div className="_row _center_align">
                        <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                        <div className="_column">
                            <input 
                                placeholder="Cari" 
                                onChange={e => set_search(e.target.value)}
                                value={search}
                            />
                        </div>
                    </div>
                </div>

                <div className="_overflow_x">
                    <table className="_table">
                        <thead>
                            <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Category</th>
                            <th>
                                <div className="_right_text">
                                    <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                                </div>
                            </th>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan="5"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <div className="_lily_pad_h_d _push_b_d _push_t_d">
                    <div className="__pagination">
                        {
                            data&&data.pages.map((item, index) => {
                                if(data.pages.length > 1){
                                    return (

                                        <div 
                                            key={index} 
                                            className="__item"
                                            style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                            onClick={() => {
                                                _read(index + 1);
                                                set_pagination_active(index + 1)
                                            }}
                                        >
                                            <div className="_position_middle">
                                                {item}
                                            </div>
                                        </div>
                                        
                                    )
                                }
                            })
                        }
                    </div>
                </div> */}

                {/* <NavLink 
                    to='/sims/export/rapor'
                    className="_btn _cursor_pointer"
                >
                    Export PDF
                </NavLink> */}
                
            {/*  End Documentation --------------------------------------------------------- */}
            
            {/*  Stuck --------------------------------------------------------------------- */}
            {/* <div style={{height: 100}}></div> */}
            {/*  End Stuck ----------------------------------------------------------------- */}

        </>
    );

}

export default Screen;